import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { MenuService } from '../../../services/menu/menu.service';
import { StickyState } from '../../../domain/menu.domain';

@Component({
  selector: 'td-wb-toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['toolbar.component.scss'],
  imports: [
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarComponent {
  @Input()
  set modal(value: boolean) {
    this._modal = value;
  }

  get modal(): boolean {
    return this._modal;
  }

  menuSticky: boolean = false;
  display: boolean = false;
  _modal: boolean = false;

  constructor(private mediaQueryService: MediaQueryService,
              private menuService: MenuService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.MD)
      .pipe(takeUntilDestroyed())
      .subscribe((state: BreakpointState): void => this.onScreenChange(state.matches));
    if (!this.modal) {
      this.menuService.onStickyStateChangeSubject
        .pipe(takeUntilDestroyed())
        .subscribe((menuState: StickyState): void => this.onMenuStateChange(menuState));
    }
  }

  private onMenuStateChange(menuState: StickyState): void {
    this.menuSticky = menuState === StickyState.STICKY;
    this.changeDetectorRef.markForCheck();
  }

  private onScreenChange(isSmallScreen: boolean): void {
    const display = this.setDisplay(isSmallScreen);
    if (display !== this.display) {
      this.display = display;
      this.changeDetectorRef.markForCheck();
    }
  }

  private setDisplay(isSmallScreen: boolean): boolean {
    return !isSmallScreen;
  }
}
